export { SystemLogo } from './component';
